import { useDebounceFn } from 'ahooks';

/**
 * @description https://ahooks.js.org/hooks/use-debounce-fn
 */
export default useDebounceFn;
